//
//  SDKExporterConfigurationProperty.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
export var ExporterConfigurationPropertyType;
(function (ExporterConfigurationPropertyType) {
    ExporterConfigurationPropertyType["string"] = "string";
    ExporterConfigurationPropertyType["number"] = "number";
    ExporterConfigurationPropertyType["boolean"] = "boolean";
    ExporterConfigurationPropertyType["enum"] = "enum";
    ExporterConfigurationPropertyType["image"] = "image";
    ExporterConfigurationPropertyType["color"] = "color";
    ExporterConfigurationPropertyType["typography"] = "typography";
})(ExporterConfigurationPropertyType || (ExporterConfigurationPropertyType = {}));
export var ExporterConfigurationPropertyInputType;
(function (ExporterConfigurationPropertyInputType) {
    ExporterConfigurationPropertyInputType["plain"] = "plain";
    ExporterConfigurationPropertyInputType["code"] = "code";
})(ExporterConfigurationPropertyInputType || (ExporterConfigurationPropertyInputType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ExporterConfigurationProperty {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(data, value) {
        var _a, _b, _c;
        this.label = data.label;
        this.category = data.category;
        this.description = data.description;
        this.key = data.key;
        this.type = data.type;
        this.inputType =
            (_a = data.inputType) !== null && _a !== void 0 ? _a : ExporterConfigurationPropertyInputType.plain;
        this.isMultiline = data.isMultiline;
        this.default = (_b = data.default) !== null && _b !== void 0 ? _b : null;
        this.values = (_c = data.values) !== null && _c !== void 0 ? _c : [];
        this.value = value;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Methods
    updateValue(value) {
        this.value = value;
    }
}
